import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

import { ReactComponent as BackArrow } from "../assets/icons/back-arrow.svg";

import { ReactComponent as NotificationBell } from "../assets/logo/kumudu_U.svg";
import HeaderIcon from "../assets/logo/daily-tick-header.png";
import theme from "../theme";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Banner from "../assets/banner/performance-banner.png";

import DAILY from "../assets/logo/DAILY.png";
import TICK from "../assets/logo/TICK.png";
function Header({ isDashboard, sidebarOpen, setSidebarOpen, staffName }) {
  const navigate = useNavigate();
  const location = useLocation();

  const resTheme = useTheme();
  const isMobile = useMediaQuery(resTheme.breakpoints.down("md")); // uses theme value

  const pathToTitle = {
    "/home": "Do it Now",
    "/all-service-tickets": "Select Department",
    "/raise-service-ticket": "Raise Ticket",
    "/ticketdetail": "Update Ticket",
    "/mytickets": staffName ? staffName : "My Tickets",
    "/day-end-report": "Day End Report",
    "/performance": "Performance",
    "/team": "Team",
    "/create-department": "Departments",
    "/all-stores": "Stores",
    "/ticket-panel": "Ticket Details",
    "/weekly-targets": "Weekly Targets",
  };

  const getPageTitle = (pathname) => {
    return pathToTitle[pathname] || "Do it Now";
  };

  // ✅ Performance-specific header
  if (location.pathname === "/performance") {
    return (
      <AppBar
        position="static"
        sx={{
          background: theme.lightTheme.header.performance,
          boxShadow: "none",
          px: 2,
          zIndex: 1200,
          borderRadius: !isMobile ? "16px 16px 0 0" : 0,
        }}
      >
        <Toolbar
          sx={{
            height: "56px",
          }}
        >
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: "#fff",
              width: 36,
              height: 36,
              mr: 2,
              color: "#0000",
              display: "flex",
              justifyContent: "center",
              "&:hover": { color: "#000" },
            }}
          >
            <ArrowBackIosIcon
              sx={{
                color: "#037b75ff",
                fontSize: 22,
                marginLeft: 0.8,
                padding: 0,
              }}
            />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px",
              flexGrow: 1,
              textAlign: "center",
              color: "#fff",
              // fontWeight: 700,
              mr: "48px",
            }}
          >
            Performance
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }

  if (location.pathname === "/weekly-targets") {
    return (
      <AppBar
        position="static"
        sx={{
          background: theme.lightTheme.header.performance,
          backgroundImage: `url(${Banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          boxShadow: "none",
          px: 2,
          zIndex: 1200,
          borderRadius: 2,
        }}
      >
        <Toolbar
          sx={{
            height: "76px",
          }}
        >
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: "#fff",
              width: 36,
              height: 36,
              mr: 2,
              color: "#0000",
              display: "flex",
              justifyContent: "center",
              "&:hover": { color: "#000" },
            }}
          >
            <ArrowBackIosIcon
              sx={{
                color: "#037b75ff",
                fontSize: 22,
                marginLeft: 0.8,
                padding: 0,
              }}
            />
          </IconButton>

          <Typography
            sx={{
              fontSize: "22px",
              flexGrow: 1,
              textAlign: "center",
              color: "#fff",
              fontWeight: 600,
              mr: "48px",
              textShadow: "0 5px 3px #ffffff3a",
            }}
          >
            Weekly Targets
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }

  if (location.pathname === "/ceo-dashboard") {
    return (
      <Box
        sx={{
          background: "linear-gradient(90deg, #1bb3a7 0%, #3f51b5 100%)",
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography variant="h6" color="#fff" align="center" fontWeight={600}>
          GROWTH SCORECARD
        </Typography>
      </Box>
    );
  }
  // ✅ Dashboard-specific header
  if (isDashboard) {
    return (
      <AppBar
        position="static"
        sx={{
          py: isMobile ? 1 : 0,
          bgcolor: isMobile ? "#fff" : "transparent",
          boxShadow: "none",
          px: isMobile ? 2 : 0,
          zIndex: 1200,
          // width: "95%",
        }}
      >
        <Toolbar
          sx={{
            minHeight: "62px !important",
            px: 3,
            borderRadius: 3,
            background: theme.lightTheme.header.home,
          }}
        >
          {" "}
          <IconButton
            onClick={() => setSidebarOpen(!sidebarOpen)}
            color="inherit"
            edge="start"
            sx={{
              visibility: !isMobile ? "hidden" : "",
              color: "rgba(0, 128, 128, 1)",
              backgroundColor: "#fff",
              width: 36,
              height: 36,
              borderRadius: "50%",
              "&:hover": {
                color: theme.lightTheme.themeCol,
                backgroundColor: "#fff",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              fontSize: "18px",
              flexGrow: 1,
              textAlign: "center",
              color: "#fff",
              fontWeight: 900,
            }}
          >
            <img style={{ height: "36px" }} src={HeaderIcon} />
          </Box>
          <IconButton
            edge="end"
            sx={{
              backgroundColor: "#fff",
              width: 36,
              height: 36,
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "white",
                "& svg path": {
                  fill: theme.lightTheme.themeCol,
                },
              },
            }}
          >
            <NotificationBell
              style={{
                width: 28,
                height: 28,
                color: "rgba(0, 128, 128, 1)",
              }}
            />
          </IconButton>
        </Toolbar>
      </AppBar>
    );
  }

  // ✅ Default non-dashboard header
  return (
    <AppBar
      position="static"
      sx={{
        background: theme.lightTheme.header.home,
        boxShadow: "none",
        px: 2,
        zIndex: 1200,
        borderRadius: !isMobile ? 2 : 0,
        // border: !isMobile ? "2px solid #4428A0" : "none",
        mb: !isMobile ? 1 : 0,
      }}
    >
      <Toolbar sx={{ minHeight: "56px !important" }}>
        <IconButton
          edge="start"
          onClick={() => navigate(-1)}
          sx={{
            visibility: !isMobile ? "hidden" : "",
            // mr: 2,
            fill: "#fff",
            color: "#fff",
            "&:hover": { color: theme.lightTheme.themeCol },
          }}
        >
          <BackArrow style={{ width: "10px", height: "17px", color: "#fff" }} />
        </IconButton>

        <Typography
          sx={{
            fontSize: "18px",
            flexGrow: 1,
            textAlign: "center",
            color: "#ffff",
            mr: "13px",
            fontWeight: 600,
          }}
        >
          {getPageTitle(location.pathname)}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
